import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import MemoTooltipIcon from '../../icons/TooltipIcon';

interface TooltipHelperProps {
  content: string;
}

const TooltipHelper: React.FC<TooltipHelperProps> = ({ content }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const escFunction = (e) => {
      if (e.key === 'Escape') {
        setShowTooltip(false);
      }
    };

    document.addEventListener('keydown', escFunction, false);
    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, []);

  const className = classNames('tooltip__bottom', {
    'tooltip__bottom--show': showTooltip,
  });

  return (
    <div className="tooltip">
      <button
        className="tooltip__link"
        onMouseLeave={() => setShowTooltip(false)}
        onMouseEnter={() => setShowTooltip(true)}
        onClick={(e) => {
          e.preventDefault();
          setShowTooltip(!showTooltip);
        }}
        aria-describedby="tooltip"
      >
        <MemoTooltipIcon />
      </button>
      <span className={className} role="tooltip">
        <p>{content}</p>
        <i></i>
      </span>
    </div>
  );
};

export default TooltipHelper;
